import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { photos } from './Photos'
import SimpleSpinner from '../../components/Common/SimpleSpinner'
import SystemRequirementsMG from './SystemRequirementsMG.json'
import '../News/news.css'

const VirtualTrainingMG = React.lazy(() => import('../Learning/VirtualTrainingMG'))
const SystemRequirements = React.lazy(() => import('../SystemRequirements'))
const MatrixGoldFeatures = React.lazy(() => import('./MatrixGoldFeatures'))
const Gallery = React.lazy(() => import('../Gallery'))
const Content = React.lazy(() => import('./MatrixGoldContent'))
const ReleaseNotes = React.lazy(() => import('../../components/ReleaseNotes/ReleaseNotes'))
const Error404 = React.lazy(() => import('../Error404'))
const MatrixGold3 = React.lazy(() => import('./MatrixGold3'))
const EndOfSupportPage = React.lazy(() => import('../../containers/EndOfSupportPage'))
const Membership = React.lazy(() => import('../Membership/Membership'))

const MatrixGoldRoutes = () => {
  return (
    <React.Suspense fallback={<SimpleSpinner />}>
      <Routes>
        <Route path='/' element={<Content />} />
        <Route path='features' element={<MatrixGoldFeatures />} />
        <Route path='matrix-and-rhinogold' element={<EndOfSupportPage />} />
        <Route path='matrixgold-3' element={<MatrixGold3 />} />
        <Route path='gallery' element={<Gallery product={'MG'} jsonData={photos} />} />
        <Route path='virtual-training' element={<VirtualTrainingMG />} />
        <Route path='release-notes' element={<ReleaseNotes software='matrixgold' />} />
        <Route path='release-notes/:slug' element={<ReleaseNotes software='matrixgold' activeSlug={true} />} />
        <Route path='membership' element={<Membership product='MatrixGold' />} />
        <Route
          path='/systemrequirements'
          element={<SystemRequirements product={'MG'} jsonData={SystemRequirementsMG} />}
        />
        <Route path='*' element={<Error404 />} />
      </Routes>
    </React.Suspense>
  )
}
export default MatrixGoldRoutes
